export default __webpack_public_path__ + "static/grills-0c15067f21546f418f37afcf031b6ddc.webp";